import { getMedia } from './getMedia';

export default function checkHasMediaGallery(checkout, product) {
  const media = getMedia({ checkout, product });
  return media && media.length > 1;
}
